import { stringify } from 'qs';
import request from '../../utils/request';

export async function getStudios(params) {
  return request(`/api/blade-interact/teaching-studio/getStudios?${stringify(params)}`);
}

export async function page(params) {
  return request(`/api/blade-interact/teaching-studio/page?${stringify(params)}`);
}

export async function detail(params) {
  return request(`/api/blade-interact/teaching-studio/detail?${stringify(params)}`);
}

export async function getResList(params) {
  return request(`/api/tscloud-statistics/res/page?${stringify(params)}`);
}
